import {useMutation, useQuery} from '@tanstack/react-query';
import {searchService, type SearchFilesParams} from '../services/search';

export function useSearchFiles() {
  return useMutation({
    mutationFn: (params: SearchFilesParams) => {
      return searchService.searchFiles(params);
    }
  });
}

export function useRecentSearch(limit = 4, enabled = true) {
  return useQuery({
    queryKey: ['recent-search', limit],
    queryFn: () => searchService.recentSearchFiles({limit}),
    enabled,
    staleTime: 60 * 1000,
    refetchOnMount: 'always'
  });
}
